module.exports = {
  context: {
    image: {
      src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
      alt: 'Ava Green',
      lazy: true,
      height: 600,
      width: 500
    },
    heading: 'Ava Green',
    shortDescription: 'Senior Director<br />Fresno, CA',
    url: '/stories/story-title'
  }
}
